import { render, staticRenderFns } from "./WBtnImport.vue?vue&type=template&id=93e13ed0&scoped=true&"
import script from "./WBtnImport.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnImport.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e13ed0",
  null
  
)

export default component.exports